<template>
  <div id="orderlist">
    <el-row>
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm" style="margin: 0">
        <el-col :xl="8" :lg="12" :md="16">
          <el-form-item label="选择日期：">
            <el-date-picker size="medium" v-model="searchForm.START_END" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearable>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xl="1" :lg="1" :md="4">
          <el-button size="medium" type="primary" @click="search">筛选</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe show-summary border style="width: 100%">
          <el-table-column prop="DAY" label="日期" width="100"></el-table-column>
          <el-table-column v-for="item in typeList" :label="item.CATALOG_NAME" :key="item.CATALOG_ID"
            :prop="(item.CATALOG_ID).toString()"></el-table-column>
          <el-table-column prop="SUM" label="总计" width="100"></el-table-column>
          <el-table-column width="120" label="操作">
            <template slot-scope="scope">
              <el-button @click="ExportInventory(scope.row)">导出库存</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        START_END: null,
      },
      tableData: [],
      typeList: [],
    };
  },
  methods: {
    $_daliyInventoryList() {
      const data = {
        SERVICE_ID: '10031',
        OTYPE: 77,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.START_END) {
        data.START_DAY = this.searchForm.START_END[0];
        data.END_DAY = this.searchForm.START_END[1];
      }
      http.post(data).then((res) => {
        if (res.DATA.length !== 0) {
          this.typeList = res.CATALOGS;
          this.tableData = res.DATA;
          this.$store.dispatch('DAILYINVENTORY_ALL', { searchForm: this.searchForm });
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    search() {
      this.$_daliyInventoryList();
    },
    ExportInventory(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10031',
            OTYPE: 78,
            GYS_ID: sessionStorage.getItem('tcId'),
            DATE: row.DAY,
          };
          http.post(data).then((res) => {
            window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
  created() {
    // VUEX搜索框记忆
    if (this.$store.state.DAILYINVENTORY_ALL.searchForm) {
      this.searchForm.START_END = this.$store.state.DAILYINVENTORY_ALL.searchForm.START_END;
      this.$_daliyInventoryList();
    } else {
      this.$_daliyInventoryList();
    }
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/historicalInventory.vue